import React from 'react';
import { useCoBrandingParams } from '../hooks/useCobrandingParams';

// Logos
import AirRefundHeaderLogo from './AirRefundHeaderLogo';
import visaLogo from '../assets/images/visa-logo.svg';

const AirRefundVisaLogo = () => {
  const { dynamicConfig } = useCoBrandingParams();
  const windowSearch =
    typeof window !== 'undefined' ? window?.location?.search : '';
  const hasVisaCardIssuer = windowSearch?.includes('visaCardIssuer');
  let issuer;

  if (typeof window !== 'undefined') {
    issuer = localStorage.getItem('yo:visaCardIssuer');
  }

  return (
    <>
      {!hasVisaCardIssuer ? (
        <>
          <AirRefundHeaderLogo />
          <div
            style={{
              borderLeft: '1px solid #CBD5E1',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <img
              src={visaLogo}
              alt="visaLogo"
              style={{ marginLeft: '1.25rem', height: '1.5rem' }}
            />
          </div>
        </>
      ) : (
        <>
          <a
            href={'//' + dynamicConfig.portalUrl}
            className="no-underline w-auto float-left block flex items-center"
          >
            <img
              src={`https://${dynamicConfig.portalUrl}/partnerLogos/${issuer}`}
              alt="visaLogo"
              className="ml-12 sm:ml-0 h-35 sm:h-50 inline-block mr-20"
              style={{ height: '2.5rem' }}
            />
          </a>
          <div
            style={{
              borderLeft: '1px solid #CBD5E1',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <img
              src={visaLogo}
              alt=""
              style={{ marginLeft: '1.25rem', height: '1.5rem' }}
            />
          </div>
        </>
      )}
    </>
  );
};

export default AirRefundVisaLogo;
